module.exports = __webpack_public_path__ + "img/jibie2.e2bc6555.png";